import React, { useState, useEffect } from 'react';
import NumberPicker from "react-widgets/NumberPicker";

const PauseOption = (props) => {
    const [pauseDuration, setPauseDuration ] = useState(1);
    const [ isWorking, setIsWorking ] = useState(false);
    const [ pauseError, setPauseError ] = useState(false);

    let monthLabel = "month";
    if (pauseDuration > 1) {
        monthLabel = "months";
    }

    useEffect(() => {
            let pauseErrors = props.getApiErrors(['SUB_PAUSE_SUBSCRIPTION']);

            if (isWorking) {
                setIsWorking(false);
            }

            if (pauseErrors.length) {
                let error = pauseErrors[0],
                    keys = [];
                if (error.errors.validation !== undefined) {
                    keys = Object.keys(error.errors.validation);
                    setPauseError(error.errors.validation[keys[0]]);
                } else if (error.errors.recurly !== undefined) {
                    keys = Object.keys(error.errors.recurly);
                    setPauseError(error.errors.recurly[keys[0]]);
                }

                props.deleteApiError(['SUB_PAUSE_SUBSCRIPTION']);
            }

        }, [props.app.messages]);

    const pauseSubscription = () => {
        setIsWorking(true);
        props.pauseSubscription({
            duration: pauseDuration
        });
    };

    return (
        <div className="pause-option-wrapper">
            <div className="pause-option">
                <div className="pause-title">
                    Just need a little break? You can pause your account.
                </div>
                {pauseError ? (
                    <div className="discount-error">
                        {pauseError}
                    </div>
                ) : null}
                <div className="pause-display">
                    <div className="pause-detail">
                        <div className="pitch">
                            Pause Account
                        </div>
                        <div className="pause-selection">
                            <NumberPicker
                                className="pause-picker"
                                value={pauseDuration}
                                min={1}
                                max={3}
                                onChange={(value) => {
                                    setPauseDuration(value);
                                }}/> {monthLabel}
                        </div>
                        <div className="comfort">
                            You will not be billed while paused
                        </div>
                    </div>
                </div>
                <div className="claim-button" role="button" onClick={(!isWorking) ? pauseSubscription : null}>
                    Pause account
                </div>
                {(!isWorking) ? (
                    <div className="cancel-advance" onClick={(e) => {
                        props.advance(5)
                    }}>
                        No thanks, cancel
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default PauseOption;
